// Footer.js

import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>About Shopper</h3>
          <p>Your go-to destination for all your shopping needs. Shopper offers a wide range of products at unbeatable prices.</p>
        </div>
        <div className="footer-column">
          <h3>Contact Us</h3>
          <p>Email: info@shopper.com</p>
          <p>Phone: 123-456-7890</p>
        </div>
        <div className="footer-column">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div> <br />
      <div className="footer-bottom">
        <p>&copy; 2024 Shopper All rights reserved.</p>
        <p> Made by Vikas -Full Stack Developer</p>
      </div>
    </footer>
  );
};

export default Footer;
